<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import Down from '@/assets/icons/svg/down.svg';
import Help from '@/assets/icons/svg/help.svg';
import Profile from '@/assets/icons/svg/profile.svg';
import defaultAvatar from '@/assets/img/default_avatar.png';
import Button from '@/components/Button';
import { useDropdown } from '@/composables/use-dropdown';
import { isCurrentProfile, saveCurrentProfile } from '@/helpers/current-profile';
import { getItem } from '@/helpers/storage';
import { actionTypes } from '@/store/modules/profile/profiles';

const store = useStore();
const { isOpen: isDropdownOpen, dropdownRef, close: closeDropdown, toggle: toggleDropdown } = useDropdown();

const user = ref(getItem('currentProfile'));
const avatar = ref(null);

const users = computed(() => store.state.profiles.data);
const isTrial = computed(() => store.getters.isTrial);
const userAvatar = computed(() => avatar.value || defaultAvatar);
const dropdownStyle = computed(() => ({
  opacity: isDropdownOpen.value ? 1 : 0,
  visibility: isDropdownOpen.value ? 'visible' : 'hidden',
}));

const handleChoiceProfile = (profileNumber) => {
  const selectedProfile = users.value.find((profile) => profile.profile_number === profileNumber);
  if (!selectedProfile) return;

  closeDropdown();
  if (isCurrentProfile(selectedProfile)) return;

  saveCurrentProfile(selectedProfile);
  window.location.reload();
};

onMounted(() => {
  const img = new Image();
  img.src = user.value?.avatar;
  img.onload = () => {
    avatar.value = user.value?.avatar;
  };

  store.dispatch(actionTypes.getProfiles);
});
</script>

<template>
  <ul class="account-dropdown">
    <li ref="dropdownRef" class="account-dropdown__header-item">
      <button class="header-item-link account-dropdown__trigger" type="button" @click="toggleDropdown">
        <img class="account-dropdown-image" :alt="user?.name" :src="userAvatar" />
      </button>
      <ul class="sub-menu account-dropdown__sub-menu" :style="dropdownStyle" @click="closeDropdown">
        <Down class="sub-menu__icon" />
        <div class="sub-menu__topbar"></div>
        <li class="sub-menu__item" v-if="!isTrial">
          <ul class="sub-menu__profile-list">
            <li class="sub-menu__profile-item padding-5" v-for="profile in users" :key="profile?.name">
              <button class="sub-menu__buttons-link account-dropdown__profile-button" @click="handleChoiceProfile(profile.profile_number)">
                <img class="account-dropdown-image" :alt="profile.name" :src="profile?.avatar" />
                <span>{{ profile?.name }}</span>
              </button>
            </li>
          </ul>
        </li>
        <li class="sub-menu__item">
          <ul class="sub-menu__buttons-list">
            <li class="sub-menu__buttons-item">
              <router-link to="/YourAccount" class="sub-menu__buttons-link">
                <span>{{ $t('header.accountDropdown.accountDetails') }}</span>
              </router-link>
            </li>
            <li class="sub-menu__buttons-item" v-if="!isTrial">
              <router-link to="/profiles/manage" class="sub-menu__buttons-link">
                <Profile class="sub-menu__buttons-icon" /><span> {{ $t('header.accountDropdown.manageProfiles') }}</span>
              </router-link>
            </li>
            <li class="sub-menu__buttons-item">
              <router-link to="/movies" class="sub-menu__buttons-link">
                <Help class="sub-menu__buttons-icon" /><span> {{ $t('header.accountDropdown.helpCenter') }}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="sub-menu__item">
          <Button class="account-dropdown__button-exit" link to="/logout" :label="$t('logOut')" />
        </li>
      </ul>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.padding-5 {
  padding: 5px;
}

.account-dropdown__trigger {
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 0;
}

.account-dropdown__profile-button {
  background: transparent;
  border: 0;
  color: inherit;
  cursor: pointer;
  text-align: left;
  width: 100%;
}
</style>
